import { useState, useEffect, useRef } from "react";
import { Btn, Card, Inp, Lbl, Slct } from "../ui";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";
import { subirFotoArchivo } from "./sigteFotos";
import { SigteFirmaSlot } from "./SigteFirmaSlot";

var SIGTE_BRAND = "#0F2C70";

var CHECKLIST_PUNTOS = ["Cabina", "Puertas", "Guías", "Motor", "Variador", "Freno", "UPS",
  "Polea", "Sensores", "Iluminación", "Comunicación", "Alarmas", "Cuarto de máquinas"];
var CALIFICACIONES = [
  { id: "C", bg: "#ecfdf5", color: "#059669" },
  { id: "OBS", bg: "#fffbeb", color: "#b45309" },
  { id: "NC", bg: "#fef2f2", color: "#dc2626" },
  { id: "NA", bg: "#f1f5f9", color: "#94a3b8" },
];
var PESO_CALIFICACION = { C: 100, OBS: 50, NC: 0 };
var CATEGORIAS_HALLAZGO = ["Limpieza", "Mecánico", "Eléctrico", "Puertas", "Comunicación", "Iluminación", "Estructura", "Seguridad", "Otro"];
var RIESGOS = ["Crítico", "Alto", "Medio", "Bajo"];
var RIESGO_COLOR = { "Crítico": "#dc2626", "Alto": "#ea580c", "Medio": "#d97706", "Bajo": "#059669" };

// FIRMAS_CONFIG del prototipo (sigte-prototipo.jsx:1161), con nombres de
// campo directos en vez del "rol:'tecnico' mapeado a catalogoRol:'supervisor'"
// del original: aqui no hace falta esa indireccion porque nuestro esquema ya
// tiene columnas separadas (tecnico_id/supervisor_id), no una lista generica
// de firmas. El comportamiento efectivo es identico: mantenimiento pide 3
// firmas, supervision pide 2 (sin tecnico).
var FIRMAS_CONFIG = {
  mantenimiento: [
    { campo: "tecnico", titulo: "Técnico", catalogoRol: "tecnico" },
    { campo: "supervisor", titulo: "Supervisor", catalogoRol: "supervisor" },
    { campo: "cliente", titulo: "Representante del Cliente", catalogoRol: "cliente" },
  ],
  supervision: [
    { campo: "supervisor", titulo: "Supervisor", catalogoRol: "supervisor" },
    { campo: "cliente", titulo: "Representante del Cliente", catalogoRol: "cliente" },
  ],
};
var BLANK_FIRMAS = {
  tecnico: { personalId: null, nombre: "", archivo: null },
  supervisor: { personalId: null, nombre: "", archivo: null },
  cliente: { personalId: null, nombre: "", archivo: null },
};

function todayStr() { return new Date().toISOString().split("T")[0]; }

function resultadoChecklist(checklist) {
  var valores = Object.keys(checklist).map(function (k) { return checklist[k].calificacion; }).filter(function (v) { return v && v !== "NA"; });
  if (valores.length === 0) return { porcentaje: null, tier: null };
  var suma = valores.reduce(function (acc, v) { return acc + (PESO_CALIFICACION[v] || 0); }, 0);
  var porcentaje = Math.round(suma / valores.length);
  var tier = valores.indexOf("NC") !== -1 ? "NC" : (valores.indexOf("OBS") !== -1 ? "OBS" : "C");
  return { porcentaje: porcentaje, tier: tier };
}
function fraseCalificacion(porcentaje, esSupervision) {
  if (porcentaje === null) return "Sin calificar";
  return (esSupervision ? "Cumple" : "Conforme") + " en un " + porcentaje + "%";
}
var TIER_COLOR = { C: { bg: "#ecfdf5", color: "#059669" }, OBS: { bg: "#fffbeb", color: "#b45309" }, NC: { bg: "#fef2f2", color: "#dc2626" } };

function hallazgoVacio() {
  return { categoria: null, descripcion: "", riesgo: null, recomendacion: "", tiempo: "", cita: null, fotos: [] };
}

function FotoThumb(p) {
  return (
    <div style={{ position: "relative", width: 56, height: 56, borderRadius: 8, overflow: "hidden", border: "1px solid #e2e8f0", flexShrink: 0 }}>
      <img src={p.item.previewUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      {p.item.subiendo ? <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.75)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, color: "#64748b" }}>...</div> : null}
      {p.item.error ? <div style={{ position: "absolute", inset: 0, background: "rgba(220,38,38,0.8)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 8, color: "#fff", padding: 2, textAlign: "center" }}>Error</div> : null}
      {p.onRemove ? <button type="button" onClick={p.onRemove} style={{ position: "absolute", top: 2, right: 2, width: 16, height: 16, borderRadius: 8, border: "none", background: "rgba(0,0,0,0.6)", color: "#fff", fontSize: 10, lineHeight: "16px", cursor: "pointer", padding: 0 }}>×</button> : null}
    </div>
  );
}

function FotoInput(p) {
  var inputRef = useRef(null);
  function manejar(e) {
    var file = e.target.files[0];
    e.target.value = "";
    if (file) p.onFile(file);
  }
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
      {p.items.map(function (item) { return <FotoThumb key={item.localId} item={item} onRemove={function () { p.onRemove(item.localId); }} />; })}
      <button type="button" onClick={function () { inputRef.current.click(); }}
        style={{ width: 56, height: 56, borderRadius: 8, border: "1px dashed #cbd5e1", background: "#f8fafc", color: "#94a3b8", fontSize: 20, cursor: "pointer", flexShrink: 0 }}>+</button>
      <input ref={inputRef} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={manejar} />
    </div>
  );
}

function NormaPickerModal(p) {
  var [docId, setDocId] = useState(null);
  var doc = p.normas.find(function (d) { return d.id === docId; });
  var categorias = {};
  if (doc) {
    doc.citas.forEach(function (c) {
      if (!categorias[c.categoria]) categorias[c.categoria] = [];
      categorias[c.categoria].push(c);
    });
  }
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 20, width: "100%", maxWidth: 520, maxHeight: "80vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        {!doc ? (
          <div>
            <p style={{ margin: "0 0 12px", fontSize: 14, fontWeight: 700, color: "#0f172a" }}>Selecciona una norma</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {p.normas.map(function (d) {
                return (
                  <button key={d.id} type="button" onClick={function () { setDocId(d.id); }}
                    style={{ textAlign: "left", padding: "10px 12px", borderRadius: 10, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer" }}>
                    <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{d.codigo}</p>
                    <p style={{ margin: "2px 0 0", fontSize: 12, color: "#64748b" }}>{d.titulo}</p>
                  </button>
                );
              })}
            </div>
          </div>
        ) : (
          <div>
            <button type="button" onClick={function () { setDocId(null); }} style={{ background: "none", border: "none", color: SIGTE_BRAND, fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0, marginBottom: 12 }}>&larr; {doc.codigo}</button>
            {Object.keys(categorias).map(function (cat) {
              return (
                <div key={cat} style={{ marginBottom: 14 }}>
                  <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase" }}>{cat}</p>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {categorias[cat].map(function (c) {
                      return (
                        <button key={c.id} type="button" onClick={function () { p.onPick(doc, c); }}
                          style={{ textAlign: "left", padding: "8px 10px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#f8fafc", cursor: "pointer" }}>
                          <p style={{ margin: 0, fontSize: 12, fontWeight: 600, color: "#0f172a" }}>{c.numeral} · {c.titulo}</p>
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <button type="button" onClick={p.onClose} style={{ marginTop: 4, width: "100%", padding: "9px 0", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Cancelar</button>
      </div>
    </div>
  );
}

export function SigteInspeccion() {
  var [clientes, setClientes] = useState([]);
  var [edificios, setEdificios] = useState([]);
  var [equipos, setEquipos] = useState([]);
  var [catalogos, setCatalogos] = useState([]);
  var [personal, setPersonal] = useState([]);
  var [normas, setNormas] = useState([]);
  var [loading, setLoading] = useState(true);

  var [clienteId, setClienteId] = useState(null);
  var [edificioId, setEdificioId] = useState(null);
  var [equipoId, setEquipoId] = useState(null);
  var [tipoReporte, setTipoReporte] = useState("mantenimiento");
  var [fecha, setFecha] = useState(todayStr());
  var [checklist, setChecklist] = useState({});
  var [hallazgos, setHallazgos] = useState([]);
  var [fotosGenerales, setFotosGenerales] = useState([]);
  var [firmas, setFirmas] = useState(BLANK_FIRMAS);

  var [mostrarForm, setMostrarForm] = useState(false);
  var [draft, setDraft] = useState(hallazgoVacio());
  var [mostrarNormaPicker, setMostrarNormaPicker] = useState(false);

  var [error, setError] = useState("");
  var [exito, setExito] = useState(null);
  var [guardando, setGuardando] = useState(false);
  var fotoIdCounter = useRef(0);

  useEffect(function () {
    Promise.all([
      sigteApiFetch("/clientes").then(function (r) { return r.json(); }),
      sigteApiFetch("/catalogos").then(function (r) { return r.json(); }),
      sigteApiFetch("/personal").then(function (r) { return r.json(); }),
      sigteApiFetch("/normas").then(function (r) { return r.json(); }),
    ]).then(function (res) {
      setClientes(res[0].clientes || []);
      setCatalogos(res[1].catalogos || []);
      setPersonal(res[2].personal || []);
      setNormas(res[3].normas || []);
      setLoading(false);
    });
  }, []);

  useEffect(function () {
    setEdificios([]); setEdificioId(null); setEquipos([]); setEquipoId(null);
    if (!clienteId) return;
    sigteApiFetch("/edificios?cliente_id=" + clienteId).then(function (r) { return r.json(); }).then(function (d) {
      setEdificios(d.edificios || []);
    });
  }, [clienteId]);

  useEffect(function () {
    setEquipos([]); setEquipoId(null);
    if (!edificioId) return;
    sigteApiFetch("/equipos?edificio_id=" + edificioId).then(function (r) { return r.json(); }).then(function (d) {
      setEquipos(d.equipos || []);
    });
  }, [edificioId]);

  // Autocompleta el nombre del representante del cliente al seleccionar
  // cliente; queda editable despues en SigteFirmaSlot (punto 2, ver
  // sigte_api.py:/dictamenes, que ya no lo sobreescribe con cliente.contacto).
  useEffect(function () {
    var cli = clientes.find(function (c) { return c.id === clienteId; });
    if (!cli) return;
    setFirmas(function (f) { return Object.assign({}, f, { cliente: Object.assign({}, f.cliente, { nombre: cli.contacto || "" }) }); });
  }, [clienteId, clientes]);

  function catLabel(id) {
    var c = catalogos.find(function (x) { return x.id === id; });
    return c ? c.valor : "?";
  }

  function agregarPersonal(nombre, rol, onCreated) {
    sigteApiFetchChecked("/personal", { method: "POST", body: JSON.stringify({ nombre: nombre, rol: rol }) })
      .then(function (body) {
        setPersonal(function (list) { return list.concat([body.personal]); });
        onCreated(body.personal);
      })
      .catch(function (e) { setError(e.message); });
  }

  var esSupervision = tipoReporte === "supervision";
  var firmasConfig = FIRMAS_CONFIG[tipoReporte];
  var respondidos = Object.keys(checklist).length;
  var resultado = resultadoChecklist(checklist);

  function calificar(item, val) {
    setChecklist(function (ch) { return Object.assign({}, ch, { [item]: Object.assign({ observacion: "" }, ch[item], { calificacion: val }) }); });
  }
  function setObservacion(item, texto) {
    setChecklist(function (ch) { return Object.assign({}, ch, { [item]: Object.assign({}, ch[item], { observacion: texto }) }); });
  }

  // ── fotos generales ──
  function agregarFotoGeneral(file) {
    var localId = ++fotoIdCounter.current;
    var item = { localId: localId, previewUrl: URL.createObjectURL(file), filename: null, subiendo: true, error: null };
    setFotosGenerales(function (list) { return list.concat([item]); });
    subirFotoArchivo(file).then(function (filename) {
      setFotosGenerales(function (list) { return list.map(function (f) { return f.localId === localId ? Object.assign({}, f, { filename: filename, subiendo: false }) : f; }); });
    }).catch(function (e) {
      setFotosGenerales(function (list) { return list.map(function (f) { return f.localId === localId ? Object.assign({}, f, { subiendo: false, error: e.message }) : f; }); });
    });
  }
  function quitarFotoGeneral(localId) {
    setFotosGenerales(function (list) {
      var item = list.find(function (f) { return f.localId === localId; });
      if (item) URL.revokeObjectURL(item.previewUrl);
      return list.filter(function (f) { return f.localId !== localId; });
    });
  }

  // ── hallazgos (draft) ──
  function abrirForm() { setDraft(hallazgoVacio()); setMostrarForm(true); }
  function cancelarForm() { setMostrarForm(false); setMostrarNormaPicker(false); }
  function agregarFotoDraft(file) {
    var localId = ++fotoIdCounter.current;
    var item = { localId: localId, previewUrl: URL.createObjectURL(file), filename: null, subiendo: true, error: null };
    setDraft(function (d) { return Object.assign({}, d, { fotos: d.fotos.concat([item]) }); });
    subirFotoArchivo(file).then(function (filename) {
      setDraft(function (d) { return Object.assign({}, d, { fotos: d.fotos.map(function (f) { return f.localId === localId ? Object.assign({}, f, { filename: filename, subiendo: false }) : f; }) }); });
    }).catch(function (e) {
      setDraft(function (d) { return Object.assign({}, d, { fotos: d.fotos.map(function (f) { return f.localId === localId ? Object.assign({}, f, { subiendo: false, error: e.message }) : f; }) }); });
    });
  }
  function quitarFotoDraft(localId) {
    setDraft(function (d) {
      var item = d.fotos.find(function (f) { return f.localId === localId; });
      if (item) URL.revokeObjectURL(item.previewUrl);
      return Object.assign({}, d, { fotos: d.fotos.filter(function (f) { return f.localId !== localId; }) });
    });
  }
  function agregarHallazgo() {
    if (!draft.descripcion.trim() || !draft.riesgo) return;
    setHallazgos(function (list) { return list.concat([Object.assign({}, draft, { descripcion: draft.descripcion.trim(), recomendacion: draft.recomendacion.trim(), tiempo: draft.tiempo.trim() })]); });
    setMostrarForm(false);
  }
  function quitarHallazgo(i) {
    setHallazgos(function (list) { return list.filter(function (_, x) { return x !== i; }); });
  }

  // ── submit ──
  function resetFormulario() {
    setClienteId(null); setEdificioId(null); setEquipoId(null);
    setTipoReporte("mantenimiento"); setFecha(todayStr());
    setChecklist({}); setHallazgos([]); setFotosGenerales([]); setFirmas(BLANK_FIRMAS);
    setMostrarForm(false); setDraft(hallazgoVacio());
  }

  function guardarDictamen() {
    setError("");
    if (!equipoId) { setError("Selecciona un equipo."); return; }
    var faltantes = CHECKLIST_PUNTOS.filter(function (pt) { return !checklist[pt] || !checklist[pt].calificacion; });
    if (faltantes.length) { setError("Faltan puntos del checklist por calificar: " + faltantes.join(", ")); return; }
    var obsFaltante = CHECKLIST_PUNTOS.find(function (pt) { return checklist[pt].calificacion === "OBS" && !checklist[pt].observacion.trim(); });
    if (obsFaltante) { setError("'" + obsFaltante + "' esta marcado OBS pero le falta la observacion."); return; }
    for (var i = 0; i < firmasConfig.length; i++) {
      var slot = firmasConfig[i];
      if (!firmas[slot.campo] || !firmas[slot.campo].archivo) { setError("Falta la firma de " + slot.titulo + "."); return; }
    }
    var repCliente = (firmas.cliente.nombre || "").trim();
    if (!repCliente) { setError("Falta el nombre del representante del cliente."); return; }
    var fotoSubiendo = fotosGenerales.some(function (f) { return f.subiendo; }) || hallazgos.some(function (h) { return h.fotos.some(function (f) { return f.subiendo; }); });
    if (fotoSubiendo) { setError("Espera a que terminen de subir las fotos."); return; }

    var payload = {
      equipo_id: equipoId,
      tipo_reporte: tipoReporte,
      fecha: fecha,
      checklist: CHECKLIST_PUNTOS.map(function (pt) {
        return { punto: pt, calificacion: checklist[pt].calificacion, observacion: checklist[pt].observacion || null };
      }),
      hallazgos: hallazgos.map(function (h) {
        return {
          categoria: h.categoria, descripcion: h.descripcion, riesgo: h.riesgo,
          recomendacion: h.recomendacion, tiempo: h.tiempo,
          cita_id: h.cita ? h.cita.id : null,
          fotos: h.fotos.filter(function (f) { return f.filename; }).map(function (f) { return f.filename; }),
        };
      }),
      fotos: fotosGenerales.filter(function (f) { return f.filename; }).map(function (f) { return f.filename; }),
      representante_cliente: repCliente,
      supervisor_id: firmas.supervisor.personalId,
      firma_supervisor_archivo: firmas.supervisor.archivo,
      firma_cliente_archivo: firmas.cliente.archivo,
    };
    if (tipoReporte === "mantenimiento") {
      payload.tecnico_id = firmas.tecnico.personalId;
      payload.firma_tecnico_archivo = firmas.tecnico.archivo;
    }

    setGuardando(true);
    sigteApiFetchChecked("/dictamenes", { method: "POST", body: JSON.stringify(payload) })
      .then(function (body) {
        setGuardando(false);
        setExito(body.dictamen.codigo);
        resetFormulario();
      })
      .catch(function (e) { setGuardando(false); setError(e.message); });
  }

  if (loading) return <p style={{ color: "#64748b", fontSize: 14 }}>Cargando...</p>;

  return (
    <div style={{ maxWidth: 760, margin: "0 auto" }}>
      {mostrarNormaPicker ? (
        <NormaPickerModal normas={normas} onClose={function () { setMostrarNormaPicker(false); }}
          onPick={function (doc, cita) {
            setDraft(function (d) { return Object.assign({}, d, { cita: { id: cita.id, documento_codigo: doc.codigo, numeral: cita.numeral, titulo: cita.titulo } }); });
            setMostrarNormaPicker(false);
          }} />
      ) : null}

      <h1 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", margin: "0 0 4px" }}>Orden de inspección</h1>
      <p style={{ color: "#64748b", fontSize: 13, margin: "0 0 20px" }}>{esSupervision ? "Supervisión de mantenimiento" : "Mantenimiento preventivo"}</p>

      {exito ? (
        <div style={{ background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 12, padding: "12px 16px", marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ margin: 0, fontSize: 13, color: "#059669", fontWeight: 600 }}>{"Dictamen " + exito + " guardado. El formulario se reinicio."}</p>
          <button onClick={function () { setExito(null); }} style={{ background: "none", border: "none", color: "#059669", cursor: "pointer", fontSize: 16, fontWeight: 700 }}>×</button>
        </div>
      ) : null}
      {error ? (
        <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12, padding: "12px 16px", marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ margin: 0, fontSize: 13, color: "#dc2626" }}>{error}</p>
          <button onClick={function () { setError(""); }} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 16, fontWeight: 700 }}>×</button>
        </div>
      ) : null}

      {/* Paso 1: tipo de reporte */}
      <Card sx={{ marginBottom: 16 }}>
        <p style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>1 · Tipo de reporte</p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <button type="button" onClick={function () { setTipoReporte("mantenimiento"); setFirmas(BLANK_FIRMAS); }}
            style={{ textAlign: "left", padding: 14, borderRadius: 12, border: "2px solid", borderColor: !esSupervision ? SIGTE_BRAND : "#e2e8f0", background: !esSupervision ? SIGTE_BRAND : "#fff", cursor: "pointer" }}>
            <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: !esSupervision ? "#fff" : "#0f172a" }}>Mantenimiento</p>
            <p style={{ margin: "3px 0 0", fontSize: 11, color: !esSupervision ? "rgba(255,255,255,0.7)" : "#94a3b8" }}>El técnico realiza el mantenimiento del equipo.</p>
          </button>
          <button type="button" onClick={function () { setTipoReporte("supervision"); setFirmas(BLANK_FIRMAS); }}
            style={{ textAlign: "left", padding: 14, borderRadius: 12, border: "2px solid", borderColor: esSupervision ? SIGTE_BRAND : "#e2e8f0", background: esSupervision ? SIGTE_BRAND : "#fff", cursor: "pointer" }}>
            <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: esSupervision ? "#fff" : "#0f172a" }}>Supervisión</p>
            <p style={{ margin: "3px 0 0", fontSize: 11, color: esSupervision ? "rgba(255,255,255,0.7)" : "#94a3b8" }}>El técnico supervisa un mantenimiento realizado por terceros.</p>
          </button>
        </div>
        <div style={{ marginTop: 12 }}>
          <Lbl c="Fecha" />
          <Inp type="date" value={fecha} onChange={function (e) { setFecha(e.target.value); }} sx={{ maxWidth: 200 }} />
        </div>
      </Card>

      {/* Paso 2: equipo (cascada Cliente -> Edificio -> Equipo) */}
      <Card sx={{ marginBottom: 16 }}>
        <p style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>2 · Equipo</p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 10 }}>
          <div>
            <Lbl c="Cliente" />
            <Slct value={clienteId || ""} onChange={function (e) { setClienteId(e.target.value ? parseInt(e.target.value, 10) : null); }}>
              <option value="">Selecciona un cliente...</option>
              {clientes.map(function (c) { return <option key={c.id} value={c.id}>{c.nombre}</option>; })}
            </Slct>
          </div>
          <div>
            <Lbl c="Edificio" />
            <Slct value={edificioId || ""} disabled={!clienteId} onChange={function (e) { setEdificioId(e.target.value ? parseInt(e.target.value, 10) : null); }}>
              <option value="">{clienteId ? "Selecciona un edificio..." : "Primero selecciona un cliente"}</option>
              {edificios.map(function (ed) { return <option key={ed.id} value={ed.id}>{ed.nombre}</option>; })}
            </Slct>
          </div>
          <div>
            <Lbl c="Equipo" />
            <Slct value={equipoId || ""} disabled={!edificioId} onChange={function (e) { setEquipoId(e.target.value ? parseInt(e.target.value, 10) : null); }}>
              <option value="">{edificioId ? "Selecciona un equipo..." : "Primero selecciona un edificio"}</option>
              {equipos.map(function (eq) { return <option key={eq.id} value={eq.id}>{(eq.interno || "Sin interno") + " · " + catLabel(eq.marca_id) + " " + (eq.modelo || "")}</option>; })}
            </Slct>
          </div>
        </div>
      </Card>

      {/* Paso 3: checklist */}
      <Card sx={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 10, display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#0f172a" }}>3 · Checklist</p>
          <span style={{ fontSize: 11, color: "#94a3b8" }}>{respondidos + "/" + CHECKLIST_PUNTOS.length}</span>
        </div>
        {CHECKLIST_PUNTOS.map(function (item) {
          var registro = checklist[item] || {};
          return (
            <div key={item} style={{ padding: "10px 0", borderBottom: "1px solid #f1f5f9" }}>
              <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 13, color: "#0f172a" }}>{item}</span>
                <div style={{ display: "flex", borderRadius: 8, overflow: "hidden", border: "1px solid #e2e8f0" }}>
                  {CALIFICACIONES.map(function (c) {
                    var activo = registro.calificacion === c.id;
                    return (
                      <button key={c.id} type="button" onClick={function () { calificar(item, c.id); }}
                        style={{ padding: "5px 10px", fontSize: 11, fontWeight: 700, border: "none", cursor: "pointer", background: activo ? c.color : "#fff", color: activo ? "#fff" : c.color }}>
                        {c.id}
                      </button>
                    );
                  })}
                </div>
              </div>
              {registro.calificacion === "OBS" ? (
                <input value={registro.observacion || ""} onChange={function (e) { setObservacion(item, e.target.value); }}
                  placeholder="Especifica la observación..."
                  style={{ marginTop: 8, width: "100%", boxSizing: "border-box", border: "1px solid #fde68a", background: "#fffbeb", borderRadius: 8, padding: "7px 10px", fontSize: 12 }} />
              ) : null}
            </div>
          );
        })}
        {respondidos === CHECKLIST_PUNTOS.length ? (
          <div style={{ marginTop: 14, display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", borderRadius: 10, padding: "10px 14px" }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: "#64748b" }}>Calificación general</span>
            <span style={{ padding: "4px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: (TIER_COLOR[resultado.tier] || {}).bg, color: (TIER_COLOR[resultado.tier] || {}).color }}>
              {fraseCalificacion(resultado.porcentaje, esSupervision)}
            </span>
          </div>
        ) : null}
      </Card>

      {/* Paso 4: hallazgos */}
      <Card sx={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 4, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#0f172a" }}>4 · Hallazgos</p>
          {!mostrarForm ? <button type="button" onClick={abrirForm} style={{ background: "none", border: "none", color: SIGTE_BRAND, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>+ Agregar hallazgo</button> : null}
        </div>
        <p style={{ margin: "0 0 14px", fontSize: 11, color: "#94a3b8" }}>Descripción y riesgo son obligatorios. Recomendación, tiempo, norma y fotos son opcionales.</p>

        {hallazgos.length > 0 ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: mostrarForm ? 14 : 0 }}>
            {hallazgos.map(function (h, i) {
              return (
                <div key={i} style={{ border: "1px solid #e2e8f0", borderRadius: 12, padding: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                    <div>
                      {h.categoria ? <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase" }}>{h.categoria}</p> : null}
                      <p style={{ margin: "2px 0 0", fontSize: 13, color: "#374151" }}>{h.descripcion}</p>
                    </div>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                      <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, color: RIESGO_COLOR[h.riesgo], border: "1px solid " + RIESGO_COLOR[h.riesgo] }}>{h.riesgo}</span>
                      <button type="button" onClick={function () { quitarHallazgo(i); }} style={{ background: "none", border: "none", color: "#cbd5e1", cursor: "pointer", fontSize: 14 }}>×</button>
                    </div>
                  </div>
                  <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, fontSize: 11 }}>
                    <div><span style={{ color: "#94a3b8" }}>Normativa: </span><span style={{ color: "#374151" }}>{h.cita ? h.cita.documento_codigo + ", " + h.cita.numeral : "Sin norma vinculada"}</span></div>
                    <div><span style={{ color: "#94a3b8" }}>Tiempo: </span><span style={{ color: "#374151" }}>{h.tiempo || "—"}</span></div>
                  </div>
                  {h.fotos.length > 0 ? <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>{h.fotos.map(function (f) { return <FotoThumb key={f.localId} item={f} />; })}</div> : null}
                </div>
              );
            })}
          </div>
        ) : null}

        {mostrarForm ? (
          <div style={{ background: "#f8fafc", borderRadius: 12, padding: 14 }}>
            <div style={{ marginBottom: 10 }}>
              <Lbl c="Categoría del hallazgo (opcional)" />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {CATEGORIAS_HALLAZGO.map(function (cat) {
                  var activo = draft.categoria === cat;
                  return (
                    <button key={cat} type="button" onClick={function () { setDraft(function (d) { return Object.assign({}, d, { categoria: activo ? null : cat }); }); }}
                      style={{ padding: "5px 10px", borderRadius: 8, border: "1px solid " + (activo ? SIGTE_BRAND : "#e2e8f0"), background: activo ? SIGTE_BRAND : "#fff", color: activo ? "#fff" : "#64748b", fontSize: 11, cursor: "pointer" }}>
                      {cat}
                    </button>
                  );
                })}
              </div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <Lbl c="Descripción" />
              <textarea value={draft.descripcion} onChange={function (e) { setDraft(function (d) { return Object.assign({}, d, { descripcion: e.target.value }); }); }}
                rows={2} style={{ width: "100%", boxSizing: "border-box", border: "1px solid #dde3f0", borderRadius: 8, padding: "8px 10px", fontSize: 12, fontFamily: "inherit" }} />
            </div>
            <div style={{ marginBottom: 10 }}>
              <Lbl c="Riesgo" />
              <div style={{ display: "flex", gap: 6 }}>
                {RIESGOS.map(function (r) {
                  var activo = draft.riesgo === r;
                  return (
                    <button key={r} type="button" onClick={function () { setDraft(function (d) { return Object.assign({}, d, { riesgo: r }); }); }}
                      style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid " + RIESGO_COLOR[r], background: activo ? RIESGO_COLOR[r] : "#fff", color: activo ? "#fff" : RIESGO_COLOR[r], fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
                      {r}
                    </button>
                  );
                })}
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
              <div><Lbl c="Recomendación (opcional)" /><Inp value={draft.recomendacion} onChange={function (e) { setDraft(function (d) { return Object.assign({}, d, { recomendacion: e.target.value }); }); }} /></div>
              <div><Lbl c="Tiempo estimado (opcional)" /><Inp value={draft.tiempo} onChange={function (e) { setDraft(function (d) { return Object.assign({}, d, { tiempo: e.target.value }); }); }} /></div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <Lbl c="Norma aplicable (opcional)" />
              {draft.cita ? (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: "7px 10px" }}>
                  <span style={{ fontSize: 12, color: "#0f172a" }}>{draft.cita.documento_codigo + " · " + draft.cita.numeral + " · " + draft.cita.titulo}</span>
                  <button type="button" onClick={function () { setDraft(function (d) { return Object.assign({}, d, { cita: null }); }); }} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer" }}>×</button>
                </div>
              ) : (
                <button type="button" onClick={function () { setMostrarNormaPicker(true); }} style={{ fontSize: 12, color: SIGTE_BRAND, background: "none", border: "1px solid #dde3f0", borderRadius: 8, padding: "7px 10px", cursor: "pointer" }}>Vincular norma...</button>
              )}
            </div>
            <div style={{ marginBottom: 14 }}>
              <Lbl c="Fotos (opcional)" />
              <FotoInput items={draft.fotos} onFile={agregarFotoDraft} onRemove={quitarFotoDraft} />
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button type="button" onClick={cancelarForm} style={{ flex: 1, padding: "9px 0", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Cancelar</button>
              <button type="button" onClick={agregarHallazgo} disabled={!draft.descripcion.trim() || !draft.riesgo}
                style={{ flex: 2, padding: "9px 0", borderRadius: 9, border: "none", background: SIGTE_BRAND, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", opacity: (!draft.descripcion.trim() || !draft.riesgo) ? 0.4 : 1 }}>Agregar hallazgo</button>
            </div>
          </div>
        ) : null}
      </Card>

      {/* Paso 5: evidencia general */}
      <Card sx={{ marginBottom: 16 }}>
        <p style={{ margin: "0 0 10px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>5 · Evidencia general (opcional)</p>
        <FotoInput items={fotosGenerales} onFile={agregarFotoGeneral} onRemove={quitarFotoGeneral} />
      </Card>

      {/* Paso 6: firmas */}
      <Card sx={{ marginBottom: 16 }}>
        <p style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{"6 · Firmas (" + firmasConfig.length + ")"}</p>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {firmasConfig.map(function (slot) {
            return (
              <SigteFirmaSlot key={slot.campo} titulo={slot.titulo} catalogoRol={slot.catalogoRol} personal={personal}
                value={firmas[slot.campo]}
                onChange={function (v) { setFirmas(function (f) { return Object.assign({}, f, { [slot.campo]: v }); }); }}
                onAgregarPersonal={agregarPersonal} />
            );
          })}
        </div>
      </Card>

      <Btn onClick={guardarDictamen} sx={{ width: "100%", padding: "13px 0", fontSize: 14 }}>{guardando ? "Guardando..." : "Guardar dictamen"}</Btn>
    </div>
  );
}
